import {SyncUIActDecorator} from '@gongxigames/framework/slotV2/fsm/acts/decorators/SyncUIActDecorator';
import {slotStore} from '@gongxigames/framework/slotV2/globals';

export class AutoplayStartUIAct extends SyncUIActDecorator {
    public execute(): void {
        this.emitter.emit('UI.updateUIElementsState', 'AutoplayStartUIState');
        this.startAutoplay();
        this.onExecuted?.();
    }

    protected startAutoplay(): void {
        slotStore.batchUpdate({
            playerBalanceBeforeStartAutoplay: slotStore.logic_balance.value
        });

        this.eventManager.emit('Autoplay.STARTED');
        this.emitter.emit('Autoplay.STARTED');
    }

    getName(): string {
        return 'AutoplayStartUIAct';
    }
}